module.exports = __webpack_public_path__ + "static/media/back.1200a2c9.png";